var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("alert-modal", {
        ref: "confirm",
        attrs: { cancelable: "true", alertText: _vm.alertText },
        on: {
          confirm: _vm.confirmedDeleteEmployee,
          cancel: _vm.cancelDeleteEmployee,
        },
      }),
      _vm._v(" "),
      _c("alert-modal", {
        ref: "formInvalid",
        attrs: { alertText: "Form invalid", icon: "error" },
      }),
      _vm._v(" "),
      _c(
        "picture-modal",
        {
          ref: "pictureModal",
          attrs: { views: _vm.views, config: _vm.config },
          on: { show: _vm.show, hide: _vm.hide },
        },
        [
          _c(
            "template",
            { slot: "profile" },
            [
              _c(
                "b-form",
                { staticClass: "employee-form" },
                [
                  _c(
                    "info-row",
                    {
                      staticClass: "info-main-row",
                      class: { hidden: _vm.firstNameHidden },
                      attrs: { title: _vm.$t("first_name").toLowerCase() },
                    },
                    [
                      _c("span", { class: { hidden: _vm.isEditing } }, [
                        _vm._v(_vm._s(_vm.record.first_name)),
                      ]),
                      _vm._v(" "),
                      _c("b-form-input", {
                        staticClass: "input-info-field",
                        class: { hidden: !_vm.isEditing },
                        attrs: {
                          id: "employee-first-name",
                          type: "text",
                          state: _vm.firstNameValid,
                          value: _vm.record.first_name,
                          placeholder: _vm.$t("first_name"),
                          "aria-describedby": "first-name-feedback",
                        },
                        on: { change: _vm.$v.record.first_name.$touch },
                        model: {
                          value: _vm.record.first_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.record, "first_name", $$v)
                          },
                          expression: "record.first_name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "info-row",
                    {
                      staticClass: "info-main-row",
                      class: { hidden: _vm.lastNameHidden },
                      attrs: { title: _vm.$t("last_name").toLowerCase() },
                    },
                    [
                      _c("span", { class: { hidden: _vm.isEditing } }, [
                        _vm._v(_vm._s(_vm.record.last_name)),
                      ]),
                      _vm._v(" "),
                      _c("b-form-input", {
                        staticClass: "input-info-field",
                        class: { hidden: !_vm.isEditing },
                        attrs: {
                          id: "employee-last-name",
                          type: "text",
                          state: _vm.lastNameValid,
                          value: _vm.record.last_name,
                          placeholder: _vm.$t("last_name"),
                          "aria-describedby": "last-name-feedback",
                        },
                        on: { change: _vm.$v.record.last_name.$touch },
                        model: {
                          value: _vm.record.last_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.record, "last_name", $$v)
                          },
                          expression: "record.last_name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "info-row",
                    {
                      staticClass: "info-main-row",
                      class: { hidden: _vm.emailHidden },
                      attrs: { title: _vm.$t("email").toLowerCase() },
                    },
                    [
                      _c("span", { class: { hidden: _vm.isEditing } }, [
                        _vm._v(_vm._s(_vm.record.email)),
                      ]),
                      _vm._v(" "),
                      _c("b-form-input", {
                        staticClass: "input-info-field",
                        class: { hidden: !_vm.isEditing },
                        attrs: {
                          id: "employee-email",
                          type: "email",
                          state: _vm.emailValid,
                          value: _vm.record.email,
                          placeholder: _vm.$t("email"),
                          "aria-describedby": "email-feedback",
                        },
                        on: { change: _vm.$v.record.email.$touch },
                        model: {
                          value: _vm.record.email,
                          callback: function ($$v) {
                            _vm.$set(_vm.record, "email", $$v)
                          },
                          expression: "record.email",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "info-row",
                    {
                      staticClass: "info-main-row",
                      class: { hidden: _vm.pinHidden },
                      attrs: { title: _vm.$t("pin").toLowerCase() },
                    },
                    [
                      _c("span", { class: { hidden: _vm.isEditing } }, [
                        _vm._v(
                          _vm._s(_vm.record.pin ? "****" : "Please set PIN")
                        ),
                      ]),
                      _vm._v(" "),
                      _c("b-form-input", {
                        staticClass: "input-info-field",
                        class: { hidden: !_vm.isEditing || _vm.isUpdating },
                        attrs: {
                          onKeyPress: "if(this.value.length==4) return false;",
                          minlength: "4",
                          maxlength: "4",
                          inputmode: "numeric",
                          pattern: "[0-9]{4}",
                          id: "employee-pin",
                          type: "number",
                          state: _vm.pinValid,
                          value: _vm.record.pin,
                          "aria-describedby": "pin-feedback",
                        },
                        on: { change: _vm.$v.record.pin.$touch },
                        model: {
                          value: _vm.record.pin,
                          callback: function ($$v) {
                            _vm.$set(_vm.record, "pin", $$v)
                          },
                          expression: "record.pin",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "info-row",
                    {
                      staticClass: "info-main-row",
                      class: { hidden: _vm.roleHidden },
                      attrs: { title: _vm.$t("role").toLowerCase() },
                    },
                    [
                      _c("span", { class: { hidden: _vm.isEditing } }, [
                        _vm._v(_vm._s(_vm.record.role)),
                      ]),
                      _vm._v(" "),
                      _c("b-form-select", {
                        staticClass: "role-selector",
                        class: { hidden: !_vm.isEditing },
                        attrs: {
                          options: _vm.employeeTypes,
                          id: "employee-role",
                          state: _vm.employeeTypeIdValid,
                          "aria-describedby": "employee-type-id-feedback",
                          required: "",
                        },
                        on: { change: _vm.$v.record.employee_type_id.$touch },
                        model: {
                          value: _vm.record.employee_type_id,
                          callback: function ($$v) {
                            _vm.$set(_vm.record, "employee_type_id", $$v)
                          },
                          expression: "record.employee_type_id",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "employee-description",
                          class: { hidden: !_vm.record.employee_type_id },
                        },
                        [_vm._v("(" + _vm._s(_vm.employeeDescriptions()) + ")")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "info-row",
                    {
                      staticClass: "info-main-row",
                      class: { hidden: _vm.isActiveHidden },
                      attrs: { title: _vm.$t("status").toLowerCase() },
                    },
                    [
                      _c("span", { class: { hidden: _vm.isEditing } }, [
                        _vm._v(
                          _vm._s(
                            1 === _vm.record.is_active ? "ACTIVE" : "INACTIVE"
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { class: { hidden: !_vm.isEditing } },
                        [
                          _c("toggle-button", {
                            staticClass: "active-toggle",
                            staticStyle: { "font-size": "12pt" },
                            attrs: {
                              value: 1 === _vm.record.is_active,
                              color: "#82C7EB",
                              sync: true,
                              labels: {
                                checked: "active",
                                unchecked: "inactive",
                              },
                              width: 105,
                              height: 33,
                            },
                            on: { change: _vm.$v.record.is_active.$touch },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("template", { slot: "reset_pin" }, [
            _c(
              "div",
              { staticClass: "pin-reset-container" },
              [
                _c("span", [_vm._v("Please enter a unique 4 digit pin")]),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c(
                  "b-form",
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "" } },
                      [
                        _c("b-form-input", {
                          staticClass: "pin-reset-input",
                          attrs: {
                            type: "password",
                            pattern: "[0-9]*",
                            inputmode: "numeric",
                            maxlength: "4",
                            placeholder: "pin",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      { attrs: { label: "" } },
                      [
                        _c("b-form-input", {
                          staticClass: "pin-reset-input",
                          attrs: {
                            type: "password",
                            pattern: "[0-9]*",
                            inputmode: "numeric",
                            maxlength: "4",
                            placeholder: "confirm pin",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _c("b-button", [_vm._v(" RESET PIN ")]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("template", { slot: "modal-toolbar-buttons" }, [
            !_vm.isEditing
              ? _c("span", { on: { click: _vm.deleteEmployee } }, [
                  _c("i", {
                    staticClass: "fi-trash delete-employee nav-icon modal-btn",
                  }),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("span", { on: { click: _vm.toggleEditMode } }, [
              _vm.isEditing
                ? _c("i", {
                    staticClass: "fi-save create-employee nav-icon modal-btn",
                  })
                : _c("i", {
                    staticClass: "fi-pencil edit-employee nav-icon modal-btn",
                  }),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "modal-btn", on: { click: _vm.hide } }, [
              _c("i", { staticClass: "fi-x cancel-employee-edit nav-icon" }),
            ]),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }